import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from '../components/seo'
import GraphQLErrorList from '../components/graphql-error-list'
import Hero from '../components/Hero/Hero'
import TwoColumnRow from '../components/Two-column-row/TwoColumnRow'
import Wave from '../components/Wave'
import IntegrationsContainer from '../components/Integration/IntegrationsContainer'
import GridContainer from '../components/Grids/GridContainer'
import SingleColumnRow from '../components/SingleColumn/SingleColumnRow'
import TabsContainer from '../components/Tabs/TabsContainer'
import Spotlight from '../components/Spotlight/Spotlight'
import CustomComponent from '../components/CustomComponents/CustomComponentContainer'
import VeeEssEm from '../components/CustomComponents/VSMTool/VSMGridContainer'
import CallOut from '../components/CallOut/CallOut'
import Workable from '../components/Workable/Workable'

export const query = graphql`
	query PageTemplateQuery($id: String!) {
		page: sanityPage(id: { eq: $id }) {
			title
			...PageInfo
			slug {
				current
			}
			_type
			openGraph {
				title
				description
				image {
					...SanityImage
				}
				canonicalLink
			}
		}
		site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
			title
			description
			keywords
			openGraph {
				title
				description
				image {
					...SanityImage
				}
			}
		}
	}
`

export default function Page(props) {
	const { data, errors } = props

	if (errors) {
		return (
			<>
				<GraphQLErrorList errors={errors} />
			</>
		)
	}

	const { page, site } = data || {}

	if (!site) {
		throw new Error(
			'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
		)
	}

	// TODO - Try to destructure props instead of spreading. There is a lot of information being passed that is not necessary for the components to render.

	const content = (page._rawContent || [])
		.filter((c) => !c.disabled)
		.map((c, i) => {
			let el = null
			switch (c._type) {
				case 'twoColumn':
					el = <TwoColumnRow key={c._key} {...c} />
					break
				case 'customerSpotlight':
					el = <Spotlight key={c._key} {...c} />
					break
				case 'oneColumn':
					el = <SingleColumnRow key={c._key} center={c.center} {...c} />
					break
				case 'hero':
					el = <Hero key={c._key} {...c} />
					break
				case 'integrationContainer':
					el = <IntegrationsContainer key={c._key} {...c} />
					break
				case 'gridContainer':
					el = <GridContainer key={c._key} {...c} />
					break
				case 'tabsContainer':
					el = <TabsContainer key={c._key} {...c} />
					break
				case 'customComponent':
					el = <CustomComponent key={c._key} fullWidth={c.fullWidth} {...c} />
					break
				case 'vsmGridContainer':
					el = <VeeEssEm key={c._key} {...c} />
					break
				case 'uiComponentRef':
					switch (c.name) {
						case 'waveBelow':
							el = <Wave waveBelow key={c._key} {...c} />
							break
						case 'waveAbove':
							el = <Wave waveAbove key={c._key} {...c} />
							break
						default:
							break
					}
					break
				case 'callOut':
					el = <CallOut key={c._key} {...c} />
					break
				case 'workable':
					el = <Workable key={c._key} {...c} />
					break
				default:
					el = null
			}
			return el
		})

	let title = ''
	let description = ''
	let image = {}
	let canonical = ''

	if (page.openGraph) {
		if (page.openGraph.title) {
			title = page.openGraph.title
		} else {
			title = site.title
		}

		if (page.openGraph.description) {
			description = page.openGraph.description
		} else {
			description = site.description
		}

		if (page.openGraph.image) {
			image = page.openGraph.image
		} else {
			image = site.openGraph.image
		}

		if (page.openGraph.canonicalLink) {
			canonical = page.openGraph.canonicalLink
		}
	} else {
		title = site.title
		description = site.description
		image = site.openGraph.image
	}

	return (
		<>
			<SEO
				title={title}
				description={description}
				keywords={site.keywords}
				image={image}
				bots={page.disallowRobots}
				canonical={canonical}
			/>
			{content}
		</>
	)
}
